/* global fetchDepartmentsBudgetsReportUrl exportDepartmentsBudgetsReportUrl showBudgetReviewUrl editBudgetReviewUrl showBudgetSnapshotUrl deleteBudgetReviewUrl deleteBudgetReviewActionUrl */
/* global fetchDepartmentsBudgetsArchivedReportsUrl deleteDepartmentsBudgetsArchivedReportUrl sendDepartmentsBudgetsReportEmailUrl */
/* global downloadDepartmentsBudgetsArchivedReportUrl */
/* global budgetVersions departmentsOptions isVikEnabled tab channelName markUpCategories */

import React, { useMemo, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ArchiveDepartmentsBudgetsReport from './ArchiveDepartmentsBudgetsReport';
import { DepartmentsBudgetsReportProvider } from './context/DepartmentsBudgetsReportContext';
import GenerateDepartmentsBudgetsReport from './GenerateDepartmentsBudgetsReport';

import Tabs, { RenderStrategyOnVisit } from 'CommonComponents/Tabs';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';

export default function DepartmentsBudgetsReport({ tab, fetchReportUrl }) {
    const [activeTab, setActiveTab] = useState(tab || 'departments-budgets-report---generate-report');

    const tabs = useMemo(
        () => [
            {
                id: 'departments-budgets-report---generate-report',
                title: $t('Generate Report'),
                content: () => <GenerateDepartmentsBudgetsReport fetchReportUrl={fetchReportUrl} />,
            },
            {
                id: 'departments-budgets-report---archive',
                title: $t('Archive'),
                content: () => <ArchiveDepartmentsBudgetsReport />,
            },
        ],
        [],
    );

    return <Tabs tabs={tabs} activeTab={activeTab} onTabActivate={setActiveTab} renderStrategy={RenderStrategyOnVisit} maxScreenHeight />;
}

if (document.getElementById('DepartmentsBudgetsReport')) {
    var rootEl = document.getElementById('DepartmentsBudgetsReport');
    ReactDOM.render(
        <App>
            <ConfirmationModalProvider>
                <DepartmentsBudgetsReportProvider
                    exportReportUrl={exportDepartmentsBudgetsReportUrl}
                    fetchArchivedReportsUrl={fetchDepartmentsBudgetsArchivedReportsUrl}
                    deleteArchivedReportUrl={deleteDepartmentsBudgetsArchivedReportUrl}
                    downloadArchivedReportUrl={downloadDepartmentsBudgetsArchivedReportUrl}
                    sendDepartmentsBudgetsReportEmailUrl={sendDepartmentsBudgetsReportEmailUrl}
                    showBudgetReviewUrl={showBudgetReviewUrl}
                    editBudgetReviewUrl={editBudgetReviewUrl}
                    showBudgetSnapshotUrl={showBudgetSnapshotUrl}
                    deleteBudgetReviewUrl={deleteBudgetReviewUrl}
                    deleteBudgetReviewActionUrl={deleteBudgetReviewActionUrl}
                    budgetVersions={budgetVersions}
                    departmentsOptions={departmentsOptions}
                    isVikEnabled={isVikEnabled}
                    channelName={channelName}
                    markUpCategories={markUpCategories}
                >
                    <DepartmentsBudgetsReport tab={tab} fetchReportUrl={fetchDepartmentsBudgetsReportUrl} />
                </DepartmentsBudgetsReportProvider>
            </ConfirmationModalProvider>
        </App>,
        rootEl,
    );
}
